import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownGender, DropdownVehicleOptions, EmptyString, FormTypeView } from "utils/Constant"
import { ApiDeleteTenant, ApiGetTenant, ApiInsertTenant, ApiUpdateTenant } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { removeNonNumeric } from "utils/helpers"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import ImageIcon from "assets/icon/ImageIcon"
import SaveIcon from "assets/icon/SaveIcon"

export default function TenantRegistration(){
    const navigate = useNavigate()

    const { fetch: insertTenant } = useFetch(ApiInsertTenant)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")

    const [tenantName, setTenantName] = useState(EmptyString)
    const [idNumber, setIdNumber] = useState(EmptyString)
    const [placeOfBirth, setPlaceOfBirth] = useState(EmptyString)
    const [dateOfBirth, setDateOfBirth] = useState(new Date())
    const [address, setAddress] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [country, setCountry] = useState("Indonesia")
    const [phone, setPhone] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [gender, setGender] = useState(DropdownGender[0].value)
    const [vehicle, setVehicle] = useState(DropdownVehicleOptions[0].value)
    const [vehicleBrand, setVehicleBrand] = useState(EmptyString)
    const [vehicleModel, setVehicleModel] = useState(EmptyString)
    const [licensePlate, setLicensePlate] = useState(EmptyString)
    const [contactName, setContactName] = useState(EmptyString)
    const [contactPhone, setContactPhone] = useState(EmptyString)
    const [contactRelation, setContactRelation] = useState(EmptyString)
    const [workPlace, setWorkPlace] = useState(EmptyString)
    
    const [errorTenantName, setErrorTenantName] = useState(false)
    const [errorIdNumber, setErrorIdNumber] = useState(false)
    const [errorPlaceOfBirth, setErrorPlaceofBirth] = useState(false)
    const [errorDateOfBirth, setErrorDateOfBirth] = useState(false)
    const [errorAddress, setErrorAddress] = useState(false)
    const [errorCity, setErrorCity] = useState(false)
    const [errorProvince, setErrorProvince] = useState(false)
    const [errorCountry, setErrorCountry] = useState(false)
    const [errorPhone, setErrorPhone] = useState(false)
    const [errorGender, setErrorGender] = useState(false)
    const [errorContactName, setErrorContactName] = useState(false)
    const [errorContactPhone, setErrorContactPhone] = useState(false)
    const [errorContactRelation, setErrorContactRelation] = useState(false)
    const [errorVehicleBrand, setErrorVehicleBrand] = useState(false)
    const [errorVehicleModel, setErrorVehicleModel] = useState(false)
    const [errorLicensePlate, setErrorLicensePlate] = useState(false)
    const [errorWorkPlace, setErrorWorkPlace] = useState(false)
    
    const tenantNameChange = (e) => { setTenantName(e.target.value.toUpperCase()) }
    const idNumberChange = (e) => { setIdNumber(removeNonNumeric(e.target.value)) }
    const placeOfBirthChange = (e) => { setPlaceOfBirth(e.target.value.toUpperCase()) }
    const dateOfBirthChange = (e) => { setDateOfBirth(e) }
    const addressChange = (e) => { setAddress(e.target.value.toUpperCase()) }
    const cityChange = (e) => { setCity(e.target.value.toUpperCase()) }
    const provinceChange = (e) => { setProvince(e.target.value.toUpperCase()) }
    const countryChange = (e) => { setCountry(e.target.value.toUpperCase()) }
    const phoneChange = (e) => { setPhone(removeNonNumeric(e.target.value)) }
    const genderChange = (e) => { setGender(e.value) }
    const vehicleChange = (e) => { setVehicle(e.value) }
    const vehicleBrandChange = (e) => { setVehicleBrand(e.target.value.toUpperCase()) }
    const vehicleModelChange = (e) => { setVehicleModel(e.target.value.toUpperCase()) }
    const licensePlateChange = (e) => { setLicensePlate(e.target.value.toUpperCase()) }
    const contactNameChange = (e) => { setContactName(e.target.value.toUpperCase()) }
    const contactPhoneChange = (e) => { setContactPhone(e.target.value) }
    const contactRelationChange = (e) => { setContactRelation(e.target.value.toUpperCase()) }
    const workPlaceChange = (e) => { setWorkPlace(e.target.value.toUpperCase()) }
    
    const handleChange = (e) => {
        setFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        // if (formType === FormTypeEdit || formType === FormTypeView){
        //     setLoading({isOpen: true})

        //     fGetTenant().then(() => {
        //         setLoading({isOpen: false})
        //     })
        // }
    }, [])


    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                fInsertTenant().then(() => {
                    setLoading({isOpen: false})
                })
            }}})
        }
    }

    function validateForm(){
        let errorCount = 0

        if (tenantName === EmptyString){
            errorCount++
            setErrorTenantName(true)
        }else{
            setErrorTenantName(false)
        }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    // Function Api Call
    async function fInsertTenant(){
        let data = new FormData()
        data.append('tenantName', tenantName.trim())
        data.append('gender', gender)
        data.append('idNumber', idNumber)
        data.append('placeOfBirth', placeOfBirth)
        data.append('dateOfBirth', moment(dateOfBirth).format("yyyy-MM-DD"))
        data.append('address', address)
        data.append('city', city)
        data.append('province', province)
        data.append('country', country)
        data.append('phone', phone)
        data.append('photoID', file)
        data.append('workPlace', workPlace)
        data.append('vehicle', vehicle)
        data.append('vehicleBrand', vehicleBrand)
        data.append('vehicleModel', vehicleModel)
        data.append('licensePlate', licensePlate)
        data.append('contactName', contactName)
        data.append('contactPhone', contactPhone)
        data.append('contactRelation', contactRelation)

        await insertTenant({
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/tenant") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    return (
        <div className="flex flex-col gap-2 p-4 sm:p-8 justify-center items-center">
            <div>
                <div className="flex flex-col justify-center items-center py-8">
                    <span className="font-semibold text-2xl">Delala Kost</span>
                    <span className="font-semibold text-xl">Tenant Registration</span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3 w-full sm:w-auto">
                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Tenant Name</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={tenantName} onChange={tenantNameChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Tenant Name is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Gender</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Dropdown className="" options={DropdownGender} value={gender} onChange={genderChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorGender ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Gender is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Id Number</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={idNumber} onChange={idNumberChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorIdNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Id Number is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Place of Birth</span>
                            </div>
                            <div className="w-full sm:w-72">
                                {formType === FormTypeView ? 
                                    <label>{ placeOfBirth }</label>
                                :
                                    <input className="input" value={placeOfBirth} onChange={placeOfBirthChange} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPlaceOfBirth ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Place of Birth is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Date of Birth</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <DatePicker className="bg-white w-full h-11" value={dateOfBirth} onChange={dateOfBirthChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorDateOfBirth ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Date of Birth is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Address</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={address} onChange={addressChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorAddress ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Address is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>City</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={city} onChange={cityChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCity ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">City is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Province</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={province} onChange={provinceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorProvince ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Province is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Country</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={country} onChange={countryChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCountry ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Country is required!</span>
                    </div>
                </div>

                {/* Phone */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Phone</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={phone} onChange={phoneChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPhone ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Phone is required!</span>
                    </div>
                </div>

                {/* Work Place */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Work Place</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={workPlace} onChange={workPlaceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorWorkPlace ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Work Place is required!</span>
                    </div>
                </div>

                {/* Vehicle */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col w-full">
                            <div className="w-48">
                                <span>Vehicle</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <Dropdown options={DropdownVehicleOptions} value={vehicle} onChange={vehicleChange} placeholder={"No Vehicle"} />
                            </div>
                        </div>
                    </div>
                </div>

                {(vehicle === '1' || vehicle === '2') && (
                    <div className="mt-4">
                        <span className="text-xl font-semibold">Vehicle Detail</span>
                        <hr />

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>Vehicle Brand</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={vehicleBrand} onChange={vehicleBrandChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorVehicleBrand ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Vehicle Brand is required!</span>
                        </div>

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>Vehicle Model</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={vehicleModel} onChange={vehicleModelChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorVehicleModel ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Vehicle Model is required!</span>
                        </div>

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>License Plate</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={licensePlate} onChange={licensePlateChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorLicensePlate ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">License Plate is required!</span>
                        </div>
                    </div>
                )}

                <div className="mt-4">
                    <div>
                        <span className="text-xl font-semibold">Tenant Emergency Contact</span>
                        <hr />

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>Contact Name</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={contactName} onChange={contactNameChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorContactName ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Contact Name is required!</span>
                        </div>

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>Contact Phone</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={contactPhone} onChange={contactPhoneChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorContactPhone ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Contact Phone is required!</span>
                        </div>

                        <div className="flex mt-4">
                            <div className="flex flex-col w-full">
                                <div className="w-48">
                                    <span>Contact Relation</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={contactRelation} onChange={contactRelationChange} />
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorContactRelation ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Contact Relation is required!</span>
                        </div>
                    </div>
                </div>

                <div className="border-b mt-4 pb-2">
                    <span className="font-semibold text-xl">Other Document</span>
                </div>
                <div className="flex">
                    <div className="flex flex-col w-full">
                        <div className="w-48">
                            <span>Photo ID</span>
                        </div>
                        <div className="w-full sm:w-72">
                            {
                                fileUrl ? <img className=" h-[180px] object-cover mx-auto border rounded-md" src={fileUrl} alt="ID" />
                                : (
                                <div className="h-[180px] w-full flex items-center justify-center border rounded-md bg-gray-100">
                                    <ImageIcon className="w-10 h-10 text-gray-400" />
                                </div>
                            )}
                            <input className="hidden" id="selectedFile" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleChange} />
                            <button onClick={() => document.getElementById('selectedFile').click()} 
                                className={`mt-4 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center 
                                        ${formType === FormTypeView ? 'hidden' : 'block'}    
                                    `}
                            >
                                <ImageIcon />
                                Add Image
                            </button>
                        </div>
                    </div>
                </div>
               
                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <button className="w-full px-4 py-2 bg-black flex gap-2 justify-center items-center rounded-md"
                        onClick={saveBtnClick}
                    >
                        <SaveIcon className="fill-white w-6" />
                        <span className="text-white">Save</span>
                    </button>
                </div>
            </div>
                
            {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}